<template>
  <div class="drag-modes" @click="toggle" v-tooltip.left="value !== 'cursor'? 'Enter guide mode': 'Enter normal mode'">
    <div class="toggle-bg" :class="{'cursor': value === 'cursor'}"></div>
    <div class="icons">
      marker
    </div>
    <div class="icons">
      guide
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DragModes',
    props: {
      value: {
        type: String
      }
    },

    methods: {
      toggle() {
        if(this.value === 'draw') {
          this.$emit('input', 'cursor')
        }  else {
          this.$emit('input', 'draw')
        }
      }
    }
  }
</script>

<style lang="scss">
@import "DragModes";
</style>
